export var VERSION = '2.5.2';
//# sourceMappingURL=version.js.map